import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import Message from "../Helpers/Message.js";
import {fetch_url_post} from "../../Sources/js/app.js";

let oper="";

let defaultInputValues={
	id: null,
	name: "",
	address: "",
	email: "",
	contact_person: "",
	phone: "",
	observations: "",
	filter_centers: "",
};

let defaultDataValues={
	centersList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let initialValue={};

const Centers = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.centerId?props.centerId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [centersList, setCentersList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.centersList.length>0) {
				dataValues.centersList.forEach(element => {
					if((value.toUpperCase()===element.name.toUpperCase())&&((value!==initialValue.name)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un centru cu acest nume!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_centers") {
			setCentersList(dataValues.centersList.filter((center)=>((center.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare centru nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			elementData.filter_centers=inputValues.filter_centers;
			initialValue=elementData;
			setInputValues(elementData);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare centru "+elementData.name});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteCenter";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("name").classList.add("required_input_error");
				return false;
			}
			if(inputValues.address==="") {
				setMessageText("Eroare: Completati campul adresa!");				
				document.getElementById("address").classList.add("required_input_error");
				return false;
			}
			let url="saveCenter";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")) {
			setDialogValues(defaultDialogValues);
			setDataValues({...dataValues,centersList:(result.centersList?result.centersList:[])});
			setCentersList(result.centersList?result.centersList.filter((center)=>((center.name.toLowerCase().indexOf(inputValues.filter_centers.toLowerCase())>-1))||(inputValues.filter_centers==="")):[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getCenters";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={4} lg={5} className="field padding-med">
						<label htmlFor="name">Nume*</label>
						<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={8} lg={7} className="field padding-med">
						<label htmlFor="address">Adresa*</label>
						<InputText name="address" id="address" style={{"width":"100%"}} value={inputValues.address} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="contact_person">Persoana de contact</label>
						<InputText name="contact_person" id="contact_person" style={{"width":"100%"}} value={inputValues.contact_person} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="email">Email</label>
						<InputText name="email" id="email" style={{"width":"100%"}} value={inputValues.email} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="phone">Telefon</label>
						<InputText name="phone" id="phone" style={{"width":"100%"}} value={inputValues.phone} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputText name="observations" id="observations" style={{"width":"100%"}} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza furnizor" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge furnizor" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
	}

	const confirm = (evt,what,elementData) => {
		if(what==="delete") {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med">
							<InputText name="filter_centers" id="filter_centers" style={{"width":"100%"}} value={inputValues.filter_centers} placeholder="Cauta centru..." onChange={(evt) => handleChange(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={6} xl={6} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{centersList.length} {(((centersList.length>1)||(centersList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med text-right">
							<Button label="Adauga centru nou" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={centersList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="name" header="Nume" style={{"flexGrow":"1","flexBasis":"230px"}} sortable></Column>
								<Column field="address" header="Adresa" style={{"flexGrow":"1","flexBasis":"255px"}}></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"195px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default Centers;


